import { Card, Skeleton, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BBA_PRIMARY } from '../../../themes/tokens';

const { Title, Text } = Typography;

interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: number | string;
  caption?: string;
  accent?: string;
  loading?: boolean;
  to?: string;
}

const StatCard: React.FC<StatCardProps> = ({
  icon, label, value, caption, accent, loading, to,
}) => {
  const navigate = useNavigate();
  const color = accent || BBA_PRIMARY;
  const [hover, setHover] = React.useState(false);

  return (
    <Card
      onClick={to ? () => navigate(to) : undefined}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        height: '100%',
        borderRadius: 12,
        border: `1px solid ${to && hover ? color : '#EEE'}`,
        cursor: to ? 'pointer' : 'default',
        transition: 'transform .15s ease, box-shadow .15s ease, border-color .15s ease',
        transform: to && hover ? 'translateY(-2px)' : undefined,
        boxShadow: to && hover ? '0 6px 18px rgba(0,0,0,0.06)' : undefined,
      }}
      styles={{ body: { padding: 20 } }}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: `${color}15`,
            color,
          }}
        >
          {icon}
        </div>
        <Text style={{ marginLeft: 12, color: '#666' }}>
          {label}
        </Text>
      </div>
      {loading ? (
        <Skeleton.Input active size="default" style={{ width: 80, height: 40 }} />
      ) : (
        <Title level={3} style={{ margin: 0, fontWeight: 700, color: '#1a1a1a' }}>
          {value}
        </Title>
      )}
      {caption && (
        <Text style={{ color: '#999', display: 'block', marginTop: 4, fontSize: 12 }}>
          {caption}
        </Text>
      )}
    </Card>
  );
};

StatCard.defaultProps = {
  caption: undefined,
  accent: undefined,
  loading: false,
  to: undefined,
};

export default StatCard;
